'use client';

import { intl } from '@frameio/i18n';
import { useAccountManagedByAdobe } from '@frameio/shared/hooks';

export type SupportLauncherId = 'intercom-launcher' | 'jarvis-launcher';

function isJapaneseLocale(locale: string): boolean {
  return locale.toLowerCase().startsWith('ja');
}

export function useJarvisSupportLauncherState(): {
  jarvisIntegrationEnabled: boolean;
  launcherId: SupportLauncherId;
} {
  const managedByAdobe = useAccountManagedByAdobe();
  const locale = intl().locale || 'en-US';
  const jarvisIntegrationEnabled = managedByAdobe && isJapaneseLocale(locale);
  const launcherId: SupportLauncherId = jarvisIntegrationEnabled
    ? 'jarvis-launcher'
    : 'intercom-launcher';

  return { jarvisIntegrationEnabled, launcherId };
}

export function useJarvisIntegrationEnabled(): boolean {
  return useJarvisSupportLauncherState().jarvisIntegrationEnabled;
}
